export default __webpack_public_path__ + "static/3_Invisalign-564d77d2f1b77089b10563682177ff86.jpg";